<template>
  <div>
    <!-- 底部导航栏 -->
    <div class="fotter">
      <div class="fotter_nav">
        <router-link
          v-for="item in NavList"
          :key="item.id"
          :to="item.path"
          @click.native="select(item.id)"
          >{{ item.name }}</router-link
        >
      </div>
      <div class="fotter_info">
        <p>北京翼任科技发展有限公司2023</p>
        <p>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            style="margin: 0 20px"
          >
            备案号：京ICP备2023030088号-1</a
          >
        </p>
        <p>
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=11011402053581"
            rel=""
            target="_blank"
          >
            <img
              src="@/assets/img/beian.png"
              alt="京公网安备11011402053581号"
            />京公网安备11011402053581号
          </a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FotterBar",
  props: {},
  data() {
    return {
      NavList: [
        {
          name: "首页",
          path: "/",
          id: 0,
        },
        {
          name: "工业物联网",
          path: "/inDusTry",
          id: 1,
        },
        {
          name: "智慧城市",
          path: "/city",
          id: 2,
        },
        {
          name: "智慧停车",
          path: "/park",
          id: 3,
        },
        {
          name: "公司介绍",
          path: "/info",
          id: 4,
        },
        {
          name: "联系我们",
          path: "/call",
          id: 5,
        },
      ],
    };
  },
  methods: {
    select(idx) {
      this.activeIndex = idx;
      window.localStorage.setItem("activeIndex", idx);
      this.$emit('changIdx',idx)
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style lang="less">
.fotter {
  background: #313131;
  // margin-top: 40px;
  position: relative;
  bottom: 0;
  .fotter_nav {
    height: 130px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: 0.5px solid gray;

    a {
      display: inline-block;
      color: #8f8f8f;
      cursor: pointer;
    }
    a:hover {
      color: white;
    }
  }
  .fotter_info {
    color: #8f8f8f;
    font-size: 16px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    a {
      color: #8c8d8f;
    }
    a:hover {
      color: white;
      transition: all 0.3s;
    }
    img {
      width: 20px;
      height: 20px;
      font-size: 0px;
      vertical-align: sub;
      margin-right: 5px;
    }
  }
}
</style>
